<template>
  <div>
    <div class="side-bar">
      <div class="bar-group">
        <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=513136985&site=qq&menu=yes">
          <el-tooltip
            popper-class="side-bar-tip"
            effect="light"
            content="联系客服"
            placement="left-start"
          >
            <i class="iconfont icon-kefu-tianchong"> </i>
          </el-tooltip>
        </a>
      </div>
      <div class="bar-group">
        <el-popover popper-class="code-pop" placement="left-start" width="30" trigger="hover">
          <span>关注微信公众号</span>
          <img width="140px" src="../assets/images/we-chat-code.jpg" alt="" />
          <i slot="reference" class="iconfont icon-weixin"></i>
        </el-popover>
      </div>
      <div class="bar-group">
        <el-tooltip
          popper-class="side-bar-tip"
          effect="light"
          content="提交反馈"
          placement="left-start"
        >
          <i class="iconfont icon-tousujianyi" @click="showSuggest"></i>
        </el-tooltip>
      </div>
      <transition name="fade">
        <div v-show="showToTop" class="bar-group">
          <el-tooltip
            popper-class="side-bar-tip"
            effect="light"
            content="回到顶部"
            placement="left-start"
          >
            <i class="iconfont icon-xiangshang" @click="toTop"></i>
          </el-tooltip>
        </div>
      </transition>
    </div>
    <el-dialog
      :lock-scroll="false"
      width="40%"
      center
      title="提交反馈"
      :before-close="close"
      :visible.sync="suggestVisible"
    >
      <el-form :model="feedback" :rules="rules" ref="feedback" label-width="0px">
        <el-form-item prop="feedContent">
          <el-input
            type="textarea"
            v-model="feedback.feedContent"
            :rows="5"
            resize="none"
            placeholder="告诉我们你的建议或遇到的问题。"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <mu-raised-button label="提 交" @click="suggestSubmit" class="demo-raised-button" primary />
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import $util from '@/services/ht.util'
  export default {
    data() {
      return {
        suggestVisible: false,
        timer: null,
        showToTop: false,
        feedback: {
          feedContent: '',
        },
        rules: {
          feedContent: {
            required: true,
            message: '内容不能为空',
            trigger: 'change',
          },
        },
      }
    },
    created() {
      window.onscroll = this.doScroll
    },
    methods: {
      showSuggest() {
        this.suggestVisible = true
      },
      suggestSubmit() {
        this.$refs.feedback.validate((v) => {
          if (v) {
            this.$doPost('SFeedBack_S', $util.RXML(this.feedback, 'SFeedBack'))
              .then((res) => {
                this.close()
                $util.doSuccess('感谢你的反馈，运价网因你而更美好！')
              })
              .catch((res) => {
                $util.doError('反馈失败')
              })
          }
        })
      },
      close() {
        this.suggestVisible = false
        this.$refs.feedback.resetFields()
      },
      doScroll() {
        if (document.documentElement.scrollTop > 100) {
          this.showToTop = true
        } else if (document.documentElement.scrollTop === 0) {
          this.showToTop = false
        }
      },
      toTop() {
        this.timer = setInterval(this.gotoTop, 1)
      },
      gotoTop() {
        let currentPosition = document.documentElement.scrollTop || document.body.scrollTop
        if (currentPosition > 3000) {
          currentPosition -= 500
        } else if (currentPosition > 2000) {
          currentPosition -= 400
        } else if (currentPosition > 1000) {
          currentPosition -= 20
        } else {
          currentPosition -= 5
        }
        currentPosition -= 20
        if (currentPosition > 0) {
          window.scrollTo(0, currentPosition)
        } else {
          window.scrollTo(0, 0)
          clearInterval(this.timer)
          this.timer = null
        }
      },
    },
  }
</script>

<style lang="scss">
  .side-bar {
    position: fixed;
    opacity: 0.2;
    bottom: 40px;
    right: 20px;
    height: 160px;
    .bar-group {
      position: relative;
      cursor: pointer;
      width: 33px;
      height: 33px;
      text-align: center;
      margin-bottom: 6px;
      border: 1px solid #ddd;
      border-radius: 50%;
      background: #eee;
      i {
        color: #333;
        font-size: 22px;
        &:hover {
          color: #03a9f4;
        }
      }
    }
    &:hover {
      opacity: 0.8;
    }
  }
  // 微信二维码弹出框
  .code-pop {
    min-width: 168px !important;
    padding: 6px 2px 0 2px !important;
    text-align: center !important;
    span {
      color: #03a9f4;
    }
  }
  // 文字提示框
  .side-bar-tip {
    border: 1px solid #03a9f4 !important;
    color: #03a9f4;
    .popper__arrow {
      border-left-color: #03a9f4 !important;
    }
  }
  // 回到顶部隐藏展示过渡
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
